import type { SVGProps } from 'react';

const SvgCloseLt = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path d='M19 5L5 19' stroke='currentColor' strokeLinecap='round' />
    <path d='M19 19L5 5' stroke='currentColor' strokeLinecap='round' />
  </svg>
);
export default SvgCloseLt;
